const americasClientId = "7c9e6679-7425-40de-944b-e07fc1f90ae7";

export default americasClientId;
